import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { eventApi } from "../api/eventApi";
import { getEvents } from "../../../modules/reducers/events/events";

const useEvent = () => {
  const dispatch = useDispatch();
  const eventList = useSelector((state) => state.events.eventList);

  useEffect(() => {
    const api = eventApi();
    dispatch(getEvents(api));
  }, []);
  return {
    eventList,
  };
};

export default useEvent;
